const ACTIONS = {
    CONTACT_OWNER_FORM_CHANGED: 'CONTACT_OWNER_FORM/CHANGED',
    CONTACT_OWNER_FORM_VALID: 'CONTACT_OWNER_FORM_VALID',
    CONTACT_OWNER_FORM_FIELD_EDITED: 'CONTACT_OWNER_FORM/FIELD_EDITED',
    CONTACT_OWNER_FORM_FIELD_TOUCHED: 'CONTACT_OWNER_FORM/FIELD_TOUCHED',
    CONTACT_OWNER_FORM_FIELD_VALID: 'CONTACT_OWNER_FORM/FIELD_VALID',
    SCROLL_TOP: 'CONTACT_OWNER_FORM/SCROLL_TOP'
};

const ACTION_CREATORS = {
    contactOwnerFormChanged(fieldsChanged) {
        return {
            type: ACTIONS.CONTACT_OWNER_FORM_CHANGED,
            payload: {
                fieldsChanged
            }
        };
    },

    contactOwnerFormFieldEdited(field, value) {
        return {
            type: ACTIONS.CONTACT_OWNER_FORM_FIELD_EDITED,
            payload: {
                field,
                value
            }
        };
    },
    contactOwnerFormFieldTouched(field, value) {
        return {
            type: ACTIONS.CONTACT_OWNER_FORM_FIELD_TOUCHED,
            payload: {
                field,
                value
            }
        };
    },
    contactOwnerFormValid(isFormValid) {
        return {
            type: ACTIONS.CONTACT_OWNER_FORM_VALID,
            payload: {
                isFormValid: !!isFormValid
            }
        };
    },
    contactOwnerFormFieldValid(field, isValid) {
        return {
            type: ACTIONS.CONTACT_OWNER_FORM_FIELD_VALID,
            payload: {
                field,
                isValid: !!isValid
            }
        };
    },
    scrollTop(scrollTop) {
        return {
            type: ACTIONS.SCROLL_TOP,
            payload: {scrollTop}
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
